import _ from "lodash"
import Vue from "vue"

const components = {
    state: {
        collections: {}
    },
    actions: {},
    mutations: {
        COLD_STORAGE_STORE: (state, payload) => {
            let collection = state.collections[payload.collection] || []
            if (_.isArray(payload.data)) {
                collection = collection.concat(payload.data)
            } else {
                collection.push(payload.data)
            }

            try {
                Vue.set(state.collections, payload.collection, collection)
            } catch(err) {
                console.log(err)
            }
        }
    },
    getters: {
        coldStorageFind: (state) => (collection, f) => {
            if (f) {
                return state.collections[collection].find(f)
            }

            return state.collections[collection]
        }
    }
  }

export default components;